var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "portlet-body form" }, [
      _c(
        "div",
        {
          staticClass: "widget-body",
          attrs: { "data-widget-id": "FORMULARIO" },
        },
        [
          _c("div", { attrs: { id: "ctl00_Main_FORMULARIO_UpdatePanel" } }, [
            _c(
              "div",
              {
                staticClass: "form-editor-view",
                attrs: { id: "ctl00_Main_FORMULARIO_PageControl" },
              },
              [
                _c(
                  "div",
                  { staticClass: "tab-content allow-focus borderless" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane active",
                        attrs: { id: "FORMULARIO_GERAL" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-body form-horizontal legend-left-caption",
                            attrs: {
                              id: "ctl00_Main_FORMULARIO_PageControl_GERAL_GERAL",
                            },
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-group col-md-2 col-sm-2 value",
                                },
                                [
                                  _c("wes-select", {
                                    attrs: {
                                      endpoint: "ED_COMPETENCIAS",
                                      "result-fields": "ANO",
                                    },
                                    on: {
                                      "item-selected": function ($event) {
                                        return _vm.anoChanged($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c(
        "div",
        {
          staticClass: "caption collapsible",
          staticStyle: { cursor: "pointer" },
          attrs: {
            onclick:
              "Benner.Widget.changeServerChromeState('ctl00_Main_FORMULARIO');",
          },
        },
        [
          _c(
            "span",
            { staticClass: "caption-subject font-green-sharp bold uppercase" },
            [_vm._v("Competências")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tools" }, [
        _c("a", {
          staticClass: "collapse",
          attrs: {
            href: "javascript:;",
            onclick:
              "Benner.Widget.changeServerChromeState('ctl00_Main_FORMULARIO');",
            "data-original-title": "",
            title: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "control-label col-md-2 col-sm-2" }, [
      _c("div", { staticClass: "label-form" }, [
        _c("div", { staticClass: "label-title" }, [_vm._v("Ano")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }